// extracted by mini-css-extract-plugin
export default {"tooltip":"cancelTooltip_tooltip__Fe+Gf","help":"cancelTooltip_help__pVAMc","arrow":"cancelTooltip_arrow__j3GFA"};